import { SelectedPanelEnum } from '../../core/enums/selected-panel.enum';
import { DirectControlButtonActionModalEnum } from '../enums/direct-control-button-action-modal.enum';
import { DirectControlButtonActionEnum } from '../enums/direct-control-button-action.enum';
import { DirectControlButtonIdEnum } from '../enums/direct-control-button-id.enum';
import { DirectControlButtonInterface } from '../interfaces/direct-control-button.interface';
import { AppRoutesEnum } from '../../routes';
import { PolicyProductIdEnum, PolicyValidityStatusCodeEnum } from 'outshared-lib';

export const directControlButtonsConfig: DirectControlButtonInterface[] = [
    {
        id: DirectControlButtonIdEnum.InsuranceStartDateSet,
        order: 10,
        name: 'Ingangsdatum verzekering opgeven',
        actionButton: true,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InsuranceStartDateSet,
        icon: null,
        productIds: [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Pet,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.Future],
    },
    {
        id: DirectControlButtonIdEnum.TransferService,
        order: 11,
        name: 'Overstapservice',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: '/mijn-verzekeringsmap/mijn-overstaphulp',
        actionPanel: SelectedPanelEnum.TransferInsurance,
        icon: null,
        productIds: [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Pet,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.Transfer],
    },
    {
        id: DirectControlButtonIdEnum.InsuranceStartDateChange,
        order: 12,
        name: 'Ingangsdatum wijzigen',
        actionButton: true,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InsuranceStartDateChange,
        icon: 'wijzig',
        productIds: [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Pet,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.Future],
    },
    {
        id: DirectControlButtonIdEnum.CancelAddedProductModal,
        order: 20,
        name: 'Verzekering annuleren',
        actionButton: true,
        action: DirectControlButtonActionEnum.Modal,
        actionModal: DirectControlButtonActionModalEnum.CancelAddedProduct,
        actionLink: '',
        icon: null,
        productIds: [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Pet,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.Transfer, PolicyValidityStatusCodeEnum.Future],
    },
    {
        id: DirectControlButtonIdEnum.InternationalMotorInsuranceCard,
        order: 30,
        name: 'Groene Kaart downloaden',
        actionButton: false,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InternationalMotorInsuranceCard,
        icon: null,
        productIds: [
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Motorcycle,
        ],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
            PolicyValidityStatusCodeEnum.Disbarred,
            PolicyValidityStatusCodeEnum.Transfer,
        ],
    },
    {
        id: DirectControlButtonIdEnum.InsuranceRegularDriver,
        order: 40,
        name: 'Regelmatige bestuurder wijzigen',
        actionButton: false,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InsuranceRegularDriver,
        icon: null,
        productIds: [
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Transfer,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ChangeCoverage,
        order: 50,
        name: 'Dekking(en) toevoegen/wijzigen',
        actionButton: true,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InsuranceCoverage,
        icon: 'wijzig',
        productIds: [
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
            PolicyProductIdEnum.Pet,
        ],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Transfer,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ReplaceCar,
        order: 60,
        name: 'Auto / kenteken vervangen',
        actionButton: false,
        action: DirectControlButtonActionEnum.ReplaceCar,
        actionLink: null,
        icon: null,
        productIds: [PolicyProductIdEnum.Car],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ExtraCar,
        order: 60,
        name: 'Extra auto verzekeren',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: '/autoverzekering/berekenen-autoverzekering',
        icon: null,
        productIds: [PolicyProductIdEnum.Car],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ReplaceMotor,
        order: 60,
        name: 'Motor / kenteken vervangen',
        actionButton: false,
        action: DirectControlButtonActionEnum.ReplaceMotorcycle,
        actionLink: null,
        icon: null,
        productIds: [PolicyProductIdEnum.Motorcycle],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ExtraMotor,
        order: 60,
        name: 'Extra motor verzekeren',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: '/motorverzekering/berekenen-motorverzekering',
        icon: null,
        productIds: [PolicyProductIdEnum.Motorcycle],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.NewHome,
        order: 60,
        name: 'Een nieuwe woning',
        actionButton: false,
        action: DirectControlButtonActionEnum.Modal,
        actionModal: DirectControlButtonActionModalEnum.NewHome,
        actionLink: '',
        icon: null,
        productIds: [PolicyProductIdEnum.Home],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.NewCaravan,
        order: 60,
        name: 'Een nieuwe caravan',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: '/caravanverzekering/berekenen-caravanverzekering',
        icon: null,
        productIds: [PolicyProductIdEnum.Caravan],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Transfer,
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.NewMoped,
        order: 60,
        name: 'Een nieuwe brommer/scooter',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: '/brommerverzekering/berekenen-brommerverzekering',
        icon: null,
        productIds: [PolicyProductIdEnum.Moped],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Transfer,
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.NewBicycle,
        order: 60,
        name: 'Een nieuwe fiets',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: '/fietsverzekering/berekenen-fietsverzekering',
        icon: null,
        productIds: [PolicyProductIdEnum.Bicycle],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Transfer,
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ReportClaim,
        order: 70,
        name: 'Schademelden',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: AppRoutesEnum.OldClaimFunnel,
        icon: null,
        productIds: [
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
            PolicyValidityStatusCodeEnum.Disbarred,
            PolicyValidityStatusCodeEnum.Ended,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ReportLegalConflic,
        order: 71,
        name: 'Juridisch conflict melden',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: AppRoutesEnum.ClaimFunnel,
        icon: null,
        productIds: [PolicyProductIdEnum.LegalAssistance],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
            PolicyValidityStatusCodeEnum.Disbarred,
            PolicyValidityStatusCodeEnum.Ended,
        ],
    },
    {
        id: DirectControlButtonIdEnum.ReportMedicalClaim,
        order: 71,
        name: 'Medische kosten declareren',
        actionButton: false,
        action: DirectControlButtonActionEnum.Link,
        actionLink: AppRoutesEnum.ClaimFunnel,
        icon: null,
        productIds: [PolicyProductIdEnum.Pet, PolicyProductIdEnum.Travel],
        validityStatusCodes: [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
            PolicyValidityStatusCodeEnum.ActiveEnded,
            PolicyValidityStatusCodeEnum.Disbarred,
            PolicyValidityStatusCodeEnum.Ended,
        ],
    },
    {
        id: DirectControlButtonIdEnum.InsuranceEndProduct,
        order: 90,
        name: 'Verzekering opzeggen',
        actionButton: true,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InsuranceEndProduct,
        icon: null,
        productIds: [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Pet,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.Active, PolicyValidityStatusCodeEnum.ActiveChange],
    },
    {
        id: DirectControlButtonIdEnum.ReviveProductModal,
        order: 91,
        name: 'Opzeggen verzekering terugdraaien',
        actionButton: true,
        action: DirectControlButtonActionEnum.Modal,
        actionModal: DirectControlButtonActionModalEnum.ReviveProduct,
        actionLink: '',
        icon: null,
        productIds: [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
            PolicyProductIdEnum.Pet,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
            PolicyProductIdEnum.Travel,
            PolicyProductIdEnum.Home,
            PolicyProductIdEnum.Bicycle,
        ],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.ActiveEnded],
    },
    {
        id: DirectControlButtonIdEnum.InsuranceEndDateProduct,
        order: 92,
        name: 'Verzekering eerder beëindigen',
        actionButton: true,
        action: DirectControlButtonActionEnum.TogglePanel,
        actionLink: '',
        actionPanel: SelectedPanelEnum.InsuranceEndDateProduct,
        icon: null,
        productIds: [PolicyProductIdEnum.Car, PolicyProductIdEnum.Motorcycle],
        validityStatusCodes: [PolicyValidityStatusCodeEnum.Disbarred],
    },
];
